export const routes = {
    landing: "/",
    home: "/home",
    questionaire: "/questionnaire",
    organizationTree: "/organization-tree"
};
